import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody, MDBInput, MDBBtn } from 'mdb-react-ui-kit';

const OtpVerification = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const email = location.state?.email || ''; // Get email from previous page via state

  const [otp, setOtp] = useState('');

  const handleVerify = async () => {
    if (!otp || !email) return alert('OTP and Email are required.');

    try {
      const res = await axios.post('https://lionsdirectoryapi.emedha.in/auth/api/api/verify-otp', { email, otp });
      alert(res.data.message);
      if (res.data.success) {
        navigate('/'); // Redirect to login page
      }
    } catch (error) {
      console.error('OTP verification failed:', error);
      alert(error.response?.data?.message || 'Verification failed.');
    }
  };

  return (
<MDBContainer
  fluid
  className="d-flex justify-content-center align-items-center"
  style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }} // optional background
>
  <MDBRow className="w-100 justify-content-center">
    <MDBCol md="6" lg="4">
      <MDBCard className="bg-warning text-white" style={{ borderRadius: '1rem' }}>
        <MDBCardBody className="p-5 text-center">
          <h3 className="mb-4">OTP Verification</h3>
          <p className="text-light mb-4">
            Enter the 6-digit OTP sent to <strong>{email}</strong>
          </p>

          <MDBInput
            type="text"
            size="lg"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            className="mb-3"
          />

               <button className="btn btn-danger mx-5 px-5" onClick={handleVerify}>
            Verify OTP
          </button>
        </MDBCardBody>
      </MDBCard>
    </MDBCol>
  </MDBRow>
</MDBContainer>

  );
};

export default OtpVerification;
